var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { isExternalLink } from '../lib/is-external-link';
import { Link } from '../lib/routing';
export const GenericLink = React.forwardRef(function GenericLink(_a, ref) {
    var { href } = _a, props = __rest(_a, ["href"]);
    if (href && href.startsWith('/')) {
        return React.createElement(Link, Object.assign({ to: href }, props, { ref: ref }));
    }
    const isExternal = isExternalLink(href);
    return (React.createElement("a", Object.assign({ href: href, target: isExternal ? '_blank' : undefined, rel: isExternal ? 'noopenner' : undefined }, props, { ref: ref })));
});
//# sourceMappingURL=generic-link.js.map